export default {
  Current: 'C',
  Leasing: 'L',
  Deposit: 'D'
}
